import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert, Card, Col,Form,Row } from "react-bootstrap";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Base_URL } from "../url";
import { FaInfoCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
const DocumentDetailsScreen = () => {
const navigate = useNavigate();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { user } = useAuth();
  const [filteredDocs, setFilteredDocs] = useState([]);

const [filters, setFilters] = useState({
  fy: "",
  fm: "",
  zDescription: "",
  fromDate: "",
  toDate: ""
});

const [fyOptions, setFyOptions] = useState([]);
const [fmOptions, setFmOptions] = useState([]);
const [descOptions, setDescOptions] = useState([]);
const fetchDocuments = async () => {
 
  try {
    setLoading(true);
    const response = await axios.get(
      `${Base_URL}/DocumentPostings/GetAllDocuments/${user?.organisationId}`
    );

    const data = response.data;

    setDocuments(data);
    setFilteredDocs(data);

    // Extract unique values
    setFyOptions([...new Set(data.map(d => d.docfy))]);
    setFmOptions([...new Set(data.map(d => d.docfm))]);
    setDescOptions([...new Set(data.map(d => d.zDescription))]);

    setLoading(false);
  } catch (err) {
    setError("Failed to fetch documents");
    setLoading(false);
  }
};
const handleFilterChange = (e) => {
  const { name, value } = e.target;
  setFilters(prev => ({ ...prev, [name]: value }));
};
  useEffect(() => {
    fetchDocuments();
  }, []);

  // const fetchDocuments = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await axios.get(
  //       `${Base_URL}/DocumentPostings/GetAllDocuments/${user?.organisationId}`
  //     );
  //     setDocuments(response.data);
  //     setLoading(false);
  //   } catch (err) {
  //     setError("Failed to fetch documents");
  //     setLoading(false);
  //   }
  // };
const applyFilters = (e) => {
  e.preventDefault();
  let filtered = [...documents];

  if (filters.fy) {
    filtered = filtered.filter(d => String(d.docfy) === String(filters.fy));
  }

  if (filters.fm) {
    filtered = filtered.filter(d => String(d.docfm) === String(filters.fm));
  }

  if (filters.zDescription) {
    filtered = filtered.filter(d => d.zDescription === filters.zDescription);
  }

  if (filters.fromDate) {
    filtered = filtered.filter(
      d => new Date(d.postingDate) >= new Date(filters.fromDate)
    );
  }

  if (filters.toDate) {
    filtered = filtered.filter(
      d => new Date(d.postingDate) <= new Date(filters.toDate)
    );
  }

  setFilteredDocs(filtered);
};
  return (
    <div className="container mt-4">
      <Card className="shadow-sm">
        <Card.Body>
          <h4 className="mb-3">Posted Documents</h4>

          {loading && (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          )}
  <Card className="mb-3 p-3 shadow-sm">
  <h5>Filters</h5>
  <div className="row">

    <div className="col-md-2">
      <label>FY</label>
      <select name="fy" className="form-control" onChange={handleFilterChange}>
        <option value="">All</option>
        {fyOptions.map((fy, i) => (
          <option key={i} value={fy}>{fy}</option>
        ))}
      </select>
    </div>

    <div className="col-md-2">
      <label>FM</label>
      <select name="fm" className="form-control" onChange={handleFilterChange}>
        <option value="">All</option>
        {fmOptions.map((fm, i) => (
          <option key={i} value={fm}>{fm}</option>
        ))}
      </select>
    </div>

    <div className="col-md-3">
      <label>Document Type</label>
      <select name="zDescription" className="form-control" onChange={handleFilterChange}>
        <option value="">All</option>
        {descOptions.map((desc, i) => (
          <option key={i} value={desc}>{desc}</option>
        ))}
      </select>
    </div>

    <div className="col-md-2">
      <label>From Date</label>
      <input type="date" name="fromDate" className="form-control" onChange={handleFilterChange}/>
    </div>

    <div className="col-md-2">
      <label>To Date</label>
      <input type="date" name="toDate" className="form-control" onChange={handleFilterChange}/>
    </div>

  </div>
  <div className="col-md-2 d-flex align-items-end">
  
</div>

  <Form>
    <Row>
      <Col md={1}>
      <button className="btn btn-primary w-100" onClick={applyFilters}>
    Apply
  </button>
      </Col>
      <Col md={1}>
        <button
    className="btn btn-secondary w-100"
    onClick={() => {
      setFilters({
        fy: "",
        fm: "",
        zDescription: "",
        fromDate: "",
        toDate: ""
      });
      setFilteredDocs(documents);
    }}
  >
    Reset
  </button>
      </Col>
    </Row>
  </Form>
</Card>
          {error && <Alert variant="danger">{error}</Alert>}

          {!loading && !error && (
            <Table bordered hover responsive>
             <thead>
  <tr>
    <th>#</th>
    <th>Doc No</th>
    <th>FY</th>
    <th>FM</th>
     <th>Document Type</th>
    <th>Document Date</th>
   
    <th>Info</th>

  </tr>
</thead>
<tbody>
  {filteredDocs.length > 0 ? (
  filteredDocs.map((doc, index) => (
      <tr key={doc.id}>
        <td>{index + 1}</td>
        <td>{doc.docno}</td>
        <td>{doc.docfy}</td>
        <td>{doc.docfm}</td>
        <td>{doc.zDescription}</td>
        <td>
          {new Date(doc.postingDate).toLocaleDateString()??"NA"}
        </td>
        <td className="text-center">
          <FaInfoCircle
            style={{ cursor: "pointer", color: "#0d6efd" }}
            onClick={() =>
              navigate(`/document-info/${doc.refNo}`,{
                state:{docno:doc.docno,
                       documentType:doc.zDescription,
                }
              })
            }
            title="View Details"
          />
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="6" className="text-center">
        No documents found
      </td>
    </tr>
  )}
</tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DocumentDetailsScreen;